import React, { Component } from 'react';
import { AvForm, AvRadio, AvRadioGroup } from 'availity-reactstrap-validation';
import i18n from '../../../../../i18next';

import { capitalizeFirstLetter } from '../../../../../utils/CommonUtils';

class BatchUpdateContent extends Component {
    componentDidMount() {
        if (this.props.inputItem === 'active') {
            this.props.onChange({
                target: {
                    name: 'multipleActivateOrDeactivate',
                    value: 'true'
                }
            })
        }
    }

    render() {
        const defaultValues = {
            [`multiple${capitalizeFirstLetter(this.props.inputItem)}Change`]: this.props.inputItem === 'active' ? 'true' : 'false' //the defaultValue model works with strings ONLY
        };

        return (
            <AvForm model={defaultValues}>

                <p>
                    {
                        this.props.inputItem === 'active' ? this.props.isActive ?

                            i18n.t(`screens:${this.props.screen}Screen.pleaseChooseActivate`) : i18n.t(`screens:${this.props.screen}Screen.pleaseChooseDisable`) :

                            i18n.t(`screens:${this.props.screen}Screen.${this.props.inputItem}${capitalizeFirstLetter(this.props.screen)}Text`)
                    }
                </p>

                <AvRadioGroup inline name={`multiple${capitalizeFirstLetter(this.props.inputItem)}Change`}>
                    <AvRadio
                        label={i18n.t('screens:answerScreen.hereOnly')}
                        name={this.props.inputItem === 'active' ? 'multipleActivateOrDeactivate' : `multiple${capitalizeFirstLetter(this.props.inputItem)}Change`}
                        value={'false'}
                        onChange={this.props.onChange}
                    />
                    <AvRadio
                        label={i18n.t('screens:answerScreen.everywhere')}
                        name={this.props.inputItem === 'active' ? 'multipleActivateOrDeactivate' : `multiple${capitalizeFirstLetter(this.props.inputItem)}Change`}
                        value={'true'}
                        onChange={this.props.onChange}
                    />
                </AvRadioGroup>
            </AvForm>
        );
    }
}

export default BatchUpdateContent;


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/common/batchUpdate/BatchUpdateContent.js